/***
* 配置文件
*/
const CNF = {
    api: process.env.REACT_APP_API,
    scmsApi: process.env.REACT_APP_SCMS_API,
    sealApi: process.env.REACT_APP_SEAL_API,
    cfmsApi: process.env.REACT_APP_CFMS_API,
    onaiApi: process.env.REACT_APP_ONAI_API,
    ossApi: process.env.REACT_APP_OSS_API,
    projectCode: 'PLMS',
    projectName: '项目综合信息管理系统',
    projectFullname: '项目综合信息管理系统',       // 项目全称
    version: '2.1.2',
    mainUrl: '',                                // 主页地址
    homeUrl: process.env.REACT_APP_HOME_URL,    // 首页地址
    loginUrl: process.env.REACT_APP_LOGIN_URL,  // 登录地址
    userUrl: process.env.REACT_APP_USER_URL,    // 设置地址
    companyShortName: '新致腾',                   //  公司简称
    locale: 'zhCN',                             // antd国际化语言
    bassicColor: '#001529',                     // 基础颜色
    safetyColor: '#308014',                     // 安全颜色
    warningColor: '#FAAD13',                    // 警告颜色
    dangerColor: '#FF0000',                     // 危险颜色
    themeColors: [    // 可选主题颜色
        '#fa541c',
        '#1677ff',
        '#13c2c2',
        '#722ed1',
        '#fa8c16',
        '#f5222d',
        '#52c41a',
        '#eb2f96',
        '#a0d911',
        '#faad14',
    ],
    isDisplayTableBorder: 0,                         // 是否显示表格边框
    cookies: {
        keySecure: true,
        keyPath: '/',
        keyDomain: process.env.REACT_APP_COOKIE_DOMAIN,
        keyExpire: 2592000,
        keyUid: 'login_xzt_uid',
        keyId: 'login_xzt_id',
        keyToken: 'login_xzt_token',
        keyUsername: 'login_xzt_username',
        keyDisplayname: 'login_xzt_displayname',
        keyAvatarUrl: 'login_xzt_avatar_url',
        keyThemeColor: 'login_xzt_theme_color',
        keyIsDisplayTableBorder: 'login_xzt_is_display_table_border',
        keyIconBrandUrl: 'login_xzt_icon_brand_url',
        keyIconSloganUrl: 'login_xzt_icon_slogan_url',
    },
    timeout: 5000,
    tDivisor: 9999999999,
    maxAge: 3600,
    fontSizeXS: 10,
    fontSizeSM: 12,
    fontSize: 14,                          // 字体大小
    fontSizeLG: 16,
    fontSizeXL: 20,
    menuHeight: 64,                        // 菜单栏高度
    menuLineHeight: 64,                    // 菜单栏行高
    messageDuration: 1.5,                  // 消息弹框持续时间，单位秒
    animateDuration: 2000,                 // 动画持续时间，单位秒
    screenWidth: 1792,                     // 系统屏幕宽度
    searchMarginLeft: 5,                   // 搜索栏左边距
    rowMarginTop: 10,                      // 行距顶部高度
    lineHeight: 2.2,                       // 行高
    tableOperationColumnWidth: 80,         // 表格操作者列宽度
    tableStatusColumnWidth: 80,            // 表格状态列宽度
    tableCreateTimeColumnWidth: 120,       // 表格创建时间列宽度
    tableCreateDisplayeColumnWidth: 90,    // 表格创建者列宽度
    maxPageSize: 65535,                    // 最大分页数，主要用于下拉列表
    pageSize: 10,                          // 分页大小
    DPL: 2,                                // 小数点长度（Decimal Point Length）
    swatches: {   // 色板
        default: ['#1983FF', '#07C9CA', '#F0884D', '#D580FF', '#7963FF', '#BD8F25', '#60C42E', '#FF80CA', '#2492B3', '#18C86F'],
    },
    currentSwatche: 'default', // 当前色板
    status: [ // 状态
        { key: '激活', value: '激活' },
        { key: '禁用', value: '禁用' },
    ],
    navItems: [ // 导航菜单
        {
            url: '/projects/bases', icon: 'trademark', m: 1, name: '项目管理', ptn: 'btn_plms_project', sub: 'sub1', submenu: [
                { url: '/projects/bases', name: '项目基础信息', icon: '', m: 11, ptn: 'btn_plms_project_base', isLogModule: true },
                { url: '/projects/details', name: '项目详细信息', icon: '', m: 12, ptn: 'btn_plms_project_detail', isLogModule: false },
                { url: '/projects/offers', name: '项目报价管理', icon: '', m: 13, ptn: 'btn_plms_project_offer', isLogModule: true },
                { url: '/projects/progressLogs', name: '项目进度日志', icon: '', m: 14, ptn: 'btn_plms_project_progress_log', isLogModule: true },
                { url: '/projects/repayments', name: '项目回款管理', icon: '', m: 15, ptn: 'btn_plms_project_repayment', isLogModule: true },
            ]
        },
        {
            url: '/cars', icon: 'message', m: 2, name: '车辆管理', ptn: 'btn_plms_car', sub: 'sub2', submenu: [
                { url: '/cars', name: '车辆信息管理', icon: '', m: 21, ptn: 'btn_plms_car', isLogModule: true },
                { url: '/cars/repairs', name: '车辆维修管理', icon: '', m: 22, ptn: 'btn_plms_car_repair', isLogModule: true },
                { url: '/cars/oils', name: '车辆油耗管理', icon: '', m: 23, ptn: 'btn_plms_car_oil', isLogModule: true },
                { url: '/cars/mileages', name: '车辆里程管理', icon: '', m: 24, ptn: 'btn_plms_car_mileage', isLogModule: true },
            ]
        },
        {
            url: '/wos', icon: 'message', m: 3, name: '工单管理', ptn: 'btn_plms_om', sub: 'sub3', submenu: [
                { url: '/wos', name: '工单信息管理', icon: '', m: 31, ptn: 'btn_plms_wo', isLogModule: true },
                { url: '/wos/visits', name: '工单回访管理', icon: '', m: 32, ptn: 'btn_plms_wo_visit', isLogModule: true, },
                { url: '/wos/dousers', name: '处理人员管理', icon: '', m: 33, ptn: 'btn_plms_wo_douser', isLogModule: true },
            ]
        },
        {
            url: '/logs/operations', icon: '', m: 4, name: '日志管理', ptn: 'btn_plms_log', sub: 'sub5', submenu: [
                { url: '/logs/operations', name: '操作日志管理', icon: '', m: 41, ptn: 'btn_plms_log_operation', isLogModule: false },
            ]
        }
    ],
    regex: { // 正则表达式
        ulid: /^[0-9A-Z]{26}$/,
        time: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/,
    },
    actionName: { // 动作名称
        CREATE: '新增',
        IMPORT: '导入',
        UPDATE: '修改',
        VISIT: '回访',
        PROGRESS: '进度',
        TOAUDIT: '送审',
        AUDIT: '审核',
        AUDITED: '审定',
        REPAYMENT: '回款',
        ARCHIVE: '档案',
        ACTIVE: '激活',
        DISABLE: '禁用',
        DELETE: '删除',
        EXPORT: '导出',
        DOWNLOAD: '下载',
    },
    auditStatus: [ // 状态
        { key: '未送审', value: '未送审' },
        { key: '已送审', value: '已送审' },
        { key: '已审定', value: '已审定' },
    ],
    projectRanks: [   //  项目等级
        { key: '主项目', value: 1 },
        { key: '子项目', value: 2 }
    ],
    projectTypes: [   //  项目类型
        { key: '集成', value: '集成' },
        { key: '软件', value: '软件' },
        { key: '硬件', value: '硬件' },
        { key: '销售', value: '销售' },
        { key: '服务', value: '服务' },
    ],
    projectPhases: [  //  项目进度
        { key: '商务洽谈', value: '商务洽谈' },
        { key: '签订合同', value: '签订合同' },
        { key: '项目启动', value: '项目启动' },
        { key: '项目实施', value: '项目实施' },
        { key: '项目初验', value: '项目初验' },
        { key: '项目终验', value: '项目终验' },
        { key: '项目审计', value: '项目审计' },
        { key: '项目运维', value: '项目运维' },
        { key: '项目结束', value: '项目结束' }
    ],
    offerStatus: [    //  报价状态
        { key: '未审定', value: '未审定' },
        { key: '已审定', value: '已审定' },
    ],
    repairTypes: [   //  车辆维修类型
        { key: '常规保养', value: '常规保养' },
        { key: '车辆小修', value: '车辆小修' },
        { key: '车辆大修', value: '车辆大修' }
    ],
    oilTypeNumbers: [     //  加油类型
        { key: '0号车用柴油Ⅵ', value: '0号车用柴油Ⅵ' },
        { key: '92号车用汽油Ⅵ', value: '92号车用汽油Ⅵ' },
        { key: '95号车用汽油Ⅵ', value: '95号车用汽油Ⅵ' }
    ],
    woLevels: [   //  工单等级
        { key: '1级工单', value: 1 },
        { key: '2级工单', value: 2 },
        { key: '3级工单', value: 3 },
        { key: '4级工单', value: 4 }
    ],
    woTypes: [    //  工单类型
        { key: '硬件', value: '硬件' },
        { key: '软件', value: '软件' },
        { key: '网络', value: '网络' },
        { key: '需求', value: '需求' },
        { key: '人工', value: '人工' },
        { key: '其他', value: '其他' }
    ],
    visitStatus: [ // 状态
        { key: '未回访', value: '未回访' },
        { key: '已回访', value: '已回访' },
    ],
    woImageMaxCount: 4,   //  单个工单最大上传的图片数
    progressLogNodeStatus: ["未开始", "进行中", "超前", "滞后", "停滞"],   //  进度日志节点状态
}

export default CNF;